import {
	useTranslate,
} from "@pankod/refine-core";
import {
	Tag,
	SelectProps,
	Select
 } from "@pankod/refine-antd";

type RoomLocationProps = {
	status: "facade" | "parking" | "minusOne" | "zero" | "one" | "two" | "three";
};

export const RoomLocation: React.FC<RoomLocationProps> = ({ status }) => {
	const t = useTranslate();
  let color;
	switch (status) {
		case "facade":
			color = "green";
			break;
		case "parking":
			color = "red";
			break;
		default:
			color = "blue";
		// case "minusOne":
		// 		color = "blue";
		// 		break;
		// case "zero":
		// 		color = "blue";
		// 		break;
		// case "one":
		// 		color = "orange";
		// 		break;
		// case "reserved":
		// 		color = "purple";
		// 		break;
}
	
	return <Tag color={color}>{t(`enum.roomLocation.${status}`)}</Tag>;
};

export const SelectRoomLocation: React.FC<any> = () => {
	const t = useTranslate();
	const selectLocation: SelectProps['options'] = [
		{ value: "facade", label: t("enum.roomLocation.facade") },
		{ value: "minusOne", label: t("enum.roomLocation.minusOne") },
		{ value: "zero", label: t("enum.roomLocation.zero") },
		{ value: "one", label: t("enum.roomLocation.one") },
		{ value: "two", label: t("enum.roomLocation.two") },
		{ value: "three", label: t("enum.roomLocation.three") },
		{ value: "parking", label: t("enum.roomLocation.parking") },
];
	return <Select options={selectLocation} />
};